/** `/$org/apps/contract-intelligence/`: the area's overview. */
import { createFileRoute } from "@tanstack/react-router";

import { CiOverviewPage } from "../components/apps/contractIntelligence/CiOverviewPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/")({
  component: CiOverviewPage,
});
